//Layout
import AdminLayout from '../layout/AdminLayout';
import MainLayout from '../layout/MainLayout';

//Admin Pages
import AdminHome from '../pages/Admin/Admin';

//Pages
import Home from '../pages/Home';
import Error404 from '../pages/Error404';
import Nosotros from '../pages/Nosotros';

const routes = [
	{
		path: '/admin',
		component: AdminLayout,
		exact: false,
		routes: [
			{
				path: '/admin',
				component: AdminHome,
				exact: true,
			},
			{
				component: Error404,
			},
		],
	},
	{
		path: '/',
		component: MainLayout,
		exact: false,
		routes: [
			{
				path: '/',
				component: Home,
				exact: true,
			},
			{
				path: '/nosotros',
				component: Nosotros,
				exact: true,
			},
			{
				component: Error404,
			},
		],
	},
];

export default routes;
